import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';

interface IHiddenAccessibilityText {
  text: string;
  ariaLive?: 'assertive' | 'polite';
}

export const HiddenAccessibilityText = ({
  text,
  ariaLive,
}: IHiddenAccessibilityText) => {
  const [reRender, setReRender] = useState(false);

  useEffect(() => {
    setReRender(!reRender);
  }, [text]);

  return (
    <Typography
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        overflow: 'hidden',
        width: '1px',
        height: '1px',
        margin: '-1px',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: '0',
      }}
      aria-live={ariaLive || 'assertive'}
      role='alert'
    >
      {text}
    </Typography>
  );
};
